export class AngularTableConfig {
    paging: boolean;
    sorting: { columns: Array<any> };
    filtering: {
        filterString: string;
        columnName: string;
    };
    className: string[];
}


// WEBPACK FOOTER //
// ./src/angular_library/models/angular-table-config.ts